<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>
<!--====================================================
                       HOME-P
======================================================-->
<div id="home-p" class="home-p pages-head1 text-center">
  <div class="container">
    <h1 class="wow fadeInUp" data-wow-delay="0.1s">
      Calidad, Confianza y Eficiencia
    </h1>
    <p>Descubre más sobre nosotros</p>
  </div>
  <!--/end container-->
</div>

<!--====================================================
                        ABOUT-P1
======================================================-->
<section id="about-p1">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="about-p1-cont">
          <h1>MundoFinanciera</h1>
          <p>
            Mundo Financiera es una empresa innovadora, que nació para acompañarte en el logro de tus metas, brindando
            soluciones de crédito con tecnología de punta.
          </p>
          <p>
            Prestamos un servicio con todas las garantías de calidad, para darte la confianza de que somos tú mejor
            aliado, siempre pensando en ser eficientes para que las ideas y necesidades de nuestros clientes sean
            atendidas con prontitud.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!--====================================================
                 ABOUT-P2
======================================================-->
<section class="about-p2 bg-gradiant">
  <div class="container-fluid">
    <!--<div class="row">
          <div class="about-p2-heading">
              <h1 class="cl-white">global leader in technology services</h1>
              <div class="heading-border-light bg-white"></div>
          </div>
      </div>-->
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <div class="about-p2-cont cl-white">
          <img src="assets/img/news/news-5.jpg" class="img-fluid wow fadeInUp" data-wow-delay="0.1s" alt="..." />
        </div>
      </div>
      <div class="col-md-4">
        <div class="about-p2-cont cl-white wow fadeInUp" data-wow-delay="0.3s">
          <h5>¿Qué es MundoFinanciera?</h5>
          <p class="cl-white">
            MundoFinanciera es una empresa innovadora, que nació para
            acompañarte en el logro de tus metas, brindando soluciones de
            crédito con tecnología de punta.
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="about-p2-cont cl-white wow fadeInUp" data-wow-delay="0.5s">
          <h5>Proposito</h5>
          <p class="cl-white">
            Prestamos un servicio con todas las garantías de calidad, para darte
            la confianza de que somos tú mejor aliado, siempre pensando en ser
            eficientes para que las ideas y necesidades de nuestros clientes
            sean atendidas con prontitud.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!--====================================================
               ABOUT-P3
======================================================-->
<section id="story" class="about-p3">
  <h3>SERVICIO ELECTRÓNICO</h3>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <p class="plataforma">Plataforma 100% virtual, que permite al comercio asociado y al usuario gestionar en línea las operaciones de
          formar
          ágil y segura.
        </p>
      </div>
      <div class="col-md-6">
        <div class="story-desc">
          <h3>PAGARE DESMATERIALIZADO</h3>
          <p><b>Pagare Desmaterializado</b> es una solución que permite gestionar su crédito de forma eficiente y
            seguro, reemplazando el título físico por un documento electrónico, creado y custodiado por DECEVAL S.A, con
            todas las garantías legales que lo respaldan jurídicamente.</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="story-himg">
          <img src="assets/img/img/image-3.jpg" class="img-fluid wow fadeInUp" data-wow-delay="0.1s" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="story-himg story-himg-middle-u">
          <img src="assets/img/img/image-2.jpg" class="img-fluid wow fadeInUp" data-wow-delay="0.1s" alt="" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="story-desc story-desc-middle">
          <h3>Firma electrónica</h3>
          <div class="heading-border-light"></div>
          <p>
            La Firma Electrónica permite validar la identidad del cliente mediante un conjunto de datos que se adjuntan a cualquier medio electrónico legítimo y permitido, cuyo propósito es darle validez jurídica mediante su firma electrónica a un título desmaterializado.
          </p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="story-himg story-himg-middle-l">
          <img src="assets/img/img/image-2.jpg" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </div>
  <!--<div class="container">
      <div class="row">
          <div class="col-md-6">
              <div class="story-desc">
                  <h3>Brand Positioning &amp; Publishing</h3>
                  <div class="heading-border-light"></div>
                  <p>Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
              </div>
          </div>
          <div class="col-md-6">
              <div class="story-himg">
                  <img src="assets/img/img/image-1.jpg" class="img-fluid wow fadeInUp" data-wow-delay="0.1s" alt="">
              </div>
          </div>
      </div>
  </div>-->
</section>
<app-footer></app-footer>
